import { Link, Text } from "designSystem/index";
import React from "react";

export default () => (
	<Link href="http://centricsoftware.com" target="_blank">
		<Text text="Centric Software" />
	</Link>
);